/**
 * Aico Featured Collection - carousel paged by columns (arrows + dots)
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  /**
   * Wire up a single section instance
   * @param {HTMLElement} root - the [data-aico-fc] section element
   */
  function init(root) {
    if (!root || root.dataset.aicoFcWired === '1') return;
    // Carousel behaviour only applies to the carousel layout
    if (root.dataset.layout && root.dataset.layout !== 'carousel') return;
    root.dataset.aicoFcWired = '1';

    var viewport = root.querySelector('[data-aico-fc-viewport]');
    var track = root.querySelector('[data-aico-fc-cards]');
    if (!viewport || !track) return;

    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    var navWrap = root.querySelector('[data-aico-fc-nav]');
    var prevBtn = root.querySelector('[data-aico-fc-prev]');
    var nextBtn = root.querySelector('[data-aico-fc-next]');
    var dotsWrap = root.querySelector('[data-aico-fc-dots]');

    var colsDesktop = parseInt(root.dataset.cols, 10) || 4;
    var colsMobile = parseInt(root.dataset.colsMobile, 10) || 2;
    var gap = parseFloat(root.dataset.gap) || 0;
    var mqMobile = window.matchMedia('(max-width: 768px)');
    var mqTablet = window.matchMedia('(max-width: 1024px)');

    var page = 0;
    var pageCount = 1;

    function cols() {
      if (mqMobile.matches) return colsMobile;
      if (mqTablet.matches) return Math.min(colsDesktop, 3);
      return colsDesktop;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (pageCount <= 1) return;
      for (var i = 0; i < pageCount; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aico-fc__dot';
        b.dataset.page = String(i);
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        dotsWrap.appendChild(b);
      }
    }

    function render() {
      var shift = viewport.clientWidth + gap;
      track.style.transform = 'translateX(' + -page * shift + 'px)';

      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= pageCount - 1;

      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.aico-fc__dot');
        for (var i = 0; i < dots.length; i++) {
          var active = i === page;
          dots[i].classList.toggle('is-active', active);
          dots[i].setAttribute('aria-selected', active ? 'true' : 'false');
        }
      }
    }

    function go(p) {
      page = Math.max(0, Math.min(pageCount - 1, p));
      render();
    }

    function recalc() {
      pageCount = Math.max(1, Math.ceil(cards.length / cols()));
      if (page > pageCount - 1) page = pageCount - 1;
      var single = pageCount <= 1;
      if (navWrap) navWrap.style.display = single ? 'none' : '';
      if (dotsWrap) dotsWrap.style.display = single ? 'none' : '';
      buildDots();
      render();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(page - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(page + 1); });

    // Touch / pointer swipe to change page
    (function () {
      var startX = 0;
      var startY = 0;
      var deltaX = 0;
      var dragging = false;
      var isHorizontal = false;
      var SWIPE_THRESHOLD = 40; // px needed to trigger a page change

      function onStart(x, y) {
        startX = x;
        startY = y;
        deltaX = 0;
        dragging = true;
        isHorizontal = false;
      }

      function onMove(x, y, e) {
        if (!dragging) return;
        deltaX = x - startX;
        var deltaY = y - startY;
        // Lock direction on first significant move
        if (!isHorizontal && Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return;
        if (!isHorizontal) {
          isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        }
        if (isHorizontal && e && e.cancelable) e.preventDefault();
      }

      function onEnd() {
        if (!dragging) return;
        dragging = false;
        if (!isHorizontal) return;
        if (deltaX <= -SWIPE_THRESHOLD) {
          go(page + 1);
        } else if (deltaX >= SWIPE_THRESHOLD) {
          go(page - 1);
        }
      }

      // Touch events
      viewport.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        onStart(t.clientX, t.clientY);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        onMove(t.clientX, t.clientY, e);
      }, { passive: false });
      viewport.addEventListener('touchend', onEnd);
      viewport.addEventListener('touchcancel', onEnd);

      // Pointer events (covers mouse drag + pen), guard against duplicate touch
      if (window.PointerEvent) {
        viewport.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return; // handled by touch events
          onStart(e.clientX, e.clientY);
        });
        viewport.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch') return;
          onMove(e.clientX, e.clientY, e);
        });
        viewport.addEventListener('pointerup', function (e) {
          if (e.pointerType === 'touch') return;
          onEnd();
        });
        viewport.addEventListener('pointercancel', function (e) {
          if (e.pointerType === 'touch') return;
          onEnd();
        });
      }
    })();

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.aico-fc__dot');
        if (!dot) return;
        go(parseInt(dot.dataset.page, 10) || 0);
      });
    }

    window.addEventListener('resize', debounce(recalc, 150));
    [mqMobile, mqTablet].forEach(function (m) {
      if (m.addEventListener) {
        m.addEventListener('change', recalc);
      } else if (m.addListener) {
        m.addListener(recalc);
      }
    });

    recalc();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-aico-fc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is (re)rendered
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });

  // Re-init carousels injected dynamically 
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-aico-fc]')) init(node);
        node.querySelectorAll('[data-aico-fc]').forEach(init);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
